import type { TeacherVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveFavoriteTeachers = createApiThunk<TeacherVM[], void>(
  "teachers/retrieveFavoriteTeachers",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.favoriteTeacherList();
  },
);
